(() => {
  const MODAL_ID = 'waldruh-size-chart-modal';
  let preferredTab = 'shirts';

  function switchTab(modalRoot, tabName) {
    const name = tabName === 'trousers' ? 'trousers' : 'shirts';
    modalRoot.querySelectorAll('.sc-panel').forEach((p) => {
      p.classList.toggle('active', p.id === `panel-${name}`);
    });
    modalRoot.querySelectorAll('.sc-tab').forEach((t) => {
      t.classList.toggle('active', t.getAttribute('data-tab') === name);
    });
  }

  function init() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    document.addEventListener(
      'click',
      (event) => {
        const trigger = event.target.closest(`[aria-controls="${MODAL_ID}"]`);
        if (!trigger) return;
        preferredTab = trigger.getAttribute('data-size-chart-tab') || 'shirts';
        // Apply as soon as possible so trousers-first never flashes shirts.
        window.setTimeout(() => switchTab(modal, preferredTab), 0);
      },
      true
    );

    modal.addEventListener('click', (event) => {
      const tab = event.target.closest('.sc-tab');
      if (!tab || !modal.contains(tab)) return;
      event.preventDefault();
      event.stopPropagation();
      const name = tab.getAttribute('data-tab');
      if (name) switchTab(modal, name);
    });

    modal.addEventListener(
      'touchend',
      (event) => {
        const tab = event.target.closest('.sc-tab');
        if (!tab || !modal.contains(tab)) return;
        event.preventDefault();
        event.stopPropagation();
        const name = tab.getAttribute('data-tab');
        if (name) switchTab(modal, name);
      },
      { passive: false }
    );

    modal.addEventListener('dialog:before-show', () => switchTab(modal, preferredTab));
    modal.addEventListener('dialog:after-show', () => switchTab(modal, preferredTab));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
